export default function Main({children}) {
    return (
      <main>
        {children}
      </main>
    );
  };
  